import axios from "axios";
import {downloadFile} from "../../../utils/file/download";


export class MaintenanceUsersService {
    /**
     * Función que hace petición al back para obtener datos para la
     * tabla en la pantalla de mantenimiento de usuarios
     * @returns {Promise<unknown>}
     */
    getDataUsers(status, idInstitucion) {
        let params = idInstitucion !== undefined
            ? {
                status: status,
                institutionIdFilter: idInstitucion
            }
            : {
                status: status
            };

        return axios.get('/appapv/getDataUsers.action', {
            params: params,
        }).then(res => res.data.payload);
    }

    getStatusList() {
        return axios.get('/appapv/getDataStatusUser.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data.payload);
    }

    getTypeUsrList() {
        return axios.get('/appapv/getDataTypeUser.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data.payload);
    }

    getDomainEmailList(idInstitution) {
        return axios.get('/appapv/getDataDomainEmail.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idInstitucion: idInstitution,
            },
        }).then(res => res.data.payload);
    }

    generatePasswords(usersString) {
        return axios.get('/appapv/generatePassword.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                usuario: usersString,
            },
        }).then(res => res.data);
    }

    /**
     * Función que hace una petición al back para insertar un nuevo elemento.
     * @param objectAccount Elemento a insertar
     * @returns {Promise<any>}
     */
    updateUser(userObject) {
        return axios.post('/appapv/updateMaintenanceUsers.action', {}, {
            params: {
                nombre: userObject.nombre ? encodeURIComponent((userObject.nombre)) : '',
                usuario: userObject.usuario ? userObject.usuario : '',
                paterno: userObject.apellidoPaterno ? encodeURIComponent((userObject.apellidoPaterno)) : '',
                materno: userObject.apellidoMaterno ? encodeURIComponent((userObject.apellidoMaterno)) : '',
                status: userObject.idStatus ? userObject.idStatus : '',
                tel1: userObject.telefono1 ? userObject.telefono1 : '',
                tel2: userObject.telefono2 ? userObject.telefono2 : '',
                fax: userObject.fax ? userObject.fax : '',
                correo: userObject.userEmail.replace(/\s/g, '') + userObject.dominio,
                tipoUsr: userObject.idTipoUsuario,
                idInstitucion: userObject.idInstitucion,
                nombreCorto: userObject.nombreCorto ? userObject.nombreCorto : '',
                isMfa: userObject.isMfa ? 1 : 0,
            }
        }).then(res => {
                this.getDataUsers();
                return res.data;
            }
        );
    }

    /**
     * Función que hace petición al back para obtener datos para la
     * tabla en la pantalla de mantenimiento de usuarios
     * @returns {Promise<unknown>}
     */
    getDataProcess(user) {
        return axios.get('/appapv/getDataProcessObjects.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                usuario: user.usuario,
                idInstitucion: user.idInstitucion,
            },
        }).then(res => res.data.payload);
    }

    assignProcess(user, objProc) {
        return axios.post('/appapv/assignProcess.action', {}, {
            params: {
                usuario: user,
                objProc: objProc,
            }
        }).then(res => res.data);
    }

    copyUserProcesses(user, copiedUser) {
        return axios.post('/appapv/copyUserProcesses.action', {}, {
            params: {
                usuario: user,
                usuarioCopia: copiedUser,
            }
        }).then(res => res.data);
    }

    /**
     * Función que hace una petición al back para obtener el
     * documento con el detalle de Mantenimiento de usuarios
     * @returns {Promise<any>}
     */
    exportMaintenanceUsers(status, idInstitucion) {
        let params = idInstitucion !== undefined
            ? {
                status: status,
                institutionIdFilter: idInstitucion
            }
            : {
                status: status
            };

        return downloadFile('/appapv/getReportMaintenanceUsersXLS.action', params);
    }

}